'use strict';

module.exports = function (connection) {
  return {
    abstractPerson: require('./abstractPerson')(connection),
    ansprechpartner: require('./ansprechpartner')(connection),
    appRole: require('./appRole')(connection),
    appUser: require('./appUser')(connection),
    dateiupload: require('./dateiupload')(connection),
    externeOrganisation: require('./externeOrganisation')(connection),
    foerderung: require('./foerderung')(connection),
    forschungsbericht: require('./forschungsbericht')(connection),
    forschungsprojekt: require('./forschungsprojekt')(connection),
    kooperation: require('./kooperation')(connection),
    land: require('./land')(connection),
    mittelgeber: require('./mittelgeber')(connection),
    nachwuchsfoerderung: require('./nachwuchsfoerderung')(connection),
    orgaIdent: require('./orgaIdent')(connection),
    organisationseinheit: require('./organisationseinheit')(connection),
    patent: require('./patent')(connection),
    patentanzahl: require('./patentanzahl')(connection),
    person: require('./person')(connection),
    personIdent: require('./personIdent')(connection),
    personIdentTyp: require('./personIdentTyp')(connection),
    preis: require('./preis')(connection),
    preisBezeichnung: require('./preisBezeichnung')(connection),
    promotionsprogrammtyp: require('./promotionsprogrammtyp')(connection),
    pubIdent: require('./pubIdent')(connection),
    pubIdentTyp: require('./pubIdentTyp')(connection),
    publikation: require('./publikation')(connection),
    publikationsupload: require('./publikationsupload')(connection),
    sdg: require('./sdg')(connection),
    strukturiertesPromotionsprogramm: require('./strukturiertesPromotionsprogramm')(connection),
    veranstaltung: require('./veranstaltung')(connection)
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/index.js
// module id = Yxer
// module chunks = 0